export enum ESituacaoGuia {
  EM_PREENCHIMENTO = 'Em Preenchimento',
  EM_PROCESSAMENTO = 'A pagar',
  PAGO = 'Paga',
  VENCIDO = 'Vencida',
  CANCELADO = 'Cancelada',
  REJEITADO = 'Rejeitada',
}

interface TipoSituacaoGuiaInfo {
  nome: string;
  indice: number;
  label: string;
  apresentarOpcaoComoFiltro: boolean;
  apresentarOpcaoComoFiltroParaExportacao: boolean;
}

export const TipoSituacaoGuiaDetalhe: { [key in ESituacaoGuia]: TipoSituacaoGuiaInfo } = {
  [ESituacaoGuia.EM_PREENCHIMENTO]: {
    nome: 'EM_PREENCHIMENTO',
    indice: 0,
    label: 'Em Preenchimento',
    apresentarOpcaoComoFiltro: true,
    apresentarOpcaoComoFiltroParaExportacao: false,
  },
  [ESituacaoGuia.EM_PROCESSAMENTO]: {
    nome: 'EM_PROCESSAMENTO',
    indice: 1,
    label: 'A pagar',
    apresentarOpcaoComoFiltro: true,
    apresentarOpcaoComoFiltroParaExportacao: true,
  },
  [ESituacaoGuia.PAGO]: {
    nome: 'PAGO',
    indice: 2,
    label: 'Paga',
    apresentarOpcaoComoFiltro: true,
    apresentarOpcaoComoFiltroParaExportacao: true,
  },
  [ESituacaoGuia.VENCIDO]: {
    nome: 'VENCIDO',
    indice: 3,
    label: 'Vencida',
    apresentarOpcaoComoFiltro: true,
    apresentarOpcaoComoFiltroParaExportacao: true,
  },
  [ESituacaoGuia.CANCELADO]: {
    nome: 'CANCELADO',
    indice: 4,
    label: 'Cancelada',
    apresentarOpcaoComoFiltro: false,
    apresentarOpcaoComoFiltroParaExportacao: false,
  },
  [ESituacaoGuia.REJEITADO]: {
    nome: 'REJEITADO',
    indice: 5,
    label: 'Rejeitada',
    apresentarOpcaoComoFiltro: false,
    apresentarOpcaoComoFiltroParaExportacao: false,
  },
};

export function getValueFromESituacaoGuiaByIndex(index: number) {
  const labels = Object.values(ESituacaoGuia);
  return labels[index];
}
